module.exports = __webpack_public_path__ + "static/media/swift.d4cc2a16.jpeg";